import { Component, signal, ViewChild } from '@angular/core';
import { DsuManagerAssessmentComponent } from '../dsu-manager-assessment/dsu-manager-assessment.component';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { BdmAssessmentComponent } from '../bdm-assessment/bdm-assessment.component';
import { NewRepChecklistComponent } from '../new-rep-checklist/new-rep-checklist.component';
import { RmAssessmentComponent } from '../rm-assessment/rm-assessment.component';
import { MatIconModule } from '@angular/material/icon';
import { DueDiliegenceComponent } from '../onboarding-assessment/due-diliegence/due-diliegence.component';
import { DsuAssessmentComponent } from '../dsu-assessment/dsu-assessment.component';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';
import { NewIntroducerChecklist } from '../new-introducer-checklist/new-introducer-checklist';
import { IntroducerRepAssessmentComponent } from '../introducer-rep-assessment/introducer-rep-assessment.component';

@Component({
  selector: 'app-dsu-managerassessment-navigation',
  imports: [
    CommonModule,
    MatTabsModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    BdmAssessmentComponent,
    NewRepChecklistComponent,
    RmAssessmentComponent,
    MatIconModule,
    DueDiliegenceComponent,
    DsuAssessmentComponent,
    DsuManagerAssessmentComponent,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent,
    IntroducerRepAssessmentComponent,
    NewIntroducerChecklist,
  ],
  templateUrl: './dsu-managerassessment-navigation.page.html',
  styleUrl: './dsu-managerassessment-navigation.page.scss'
})
export class DsuManagerassessmentNavigationPage {

  @ViewChild('DsuManagerTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  selectedIndex: number = 0;
  data = history.state;
  readonly = signal(false);
  // 2. Define the total number of tabs (update this based on your app)
  totalTabs: number = 7;
  designation!: string;

  constructor() { }
  ngOnInit(): void {
    this.selectedTabId = "new-repapplication";
    this.designation = this.data.designation;
    if (this.data.iseditable) {
      this.readonly.set(false);
    } else {
      this.readonly.set(this.data.isReadOnly);
    }
  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index; // ✅ IMPORTANT FIX

    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }


  protected nextTab(): void {
    if (this.selectedIndex < this.totalTabs - 1) {
      this.selectedIndex++; // ✅ This automatically switches tab
    }
  }
}
